import React, { useEffect, useState } from "react";
import "./SplashScreen.css";

function SplashScreen({ onDone }) {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const exitTimer = setTimeout(() => setExiting(true), 2800);
    const doneTimer = setTimeout(onDone, 3400);
    return () => {
      clearTimeout(exitTimer);
      clearTimeout(doneTimer);
    };
  }, [onDone]);

  return (
    <div className={`splash${exiting ? " splash-exit" : ""}`} aria-hidden="true">
      <div className="splash-inner">

        {/* ── Battery + Spark SVG ── */}
        <svg
          viewBox="0 0 480 160"
          className="splash-svg"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            {/* Spark glow filter */}
            <filter id="sp-glow" x="-60%" y="-60%" width="220%" height="220%">
              <feGaussianBlur stdDeviation="3" result="blur" />
              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
            {/* Battery glow filter */}
            <filter id="bat-glow" x="-20%" y="-20%" width="140%" height="140%">
              <feGaussianBlur stdDeviation="6" result="blur" />
              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
            {/* Clip to battery interior rounded rect */}
            <clipPath id="bat-clip">
              <rect x="124" y="34" width="232" height="92" rx="5" />
            </clipPath>
          </defs>

          {/* ── Battery body ── */}
          <rect className="bat-body" x="120" y="30" width="240" height="100" rx="7" />

          {/* ── Battery terminal (positive nub) ── */}
          <rect className="bat-terminal" x="360" y="50" width="14" height="60" rx="3" />

          {/* ── Cell divider lines ── */}
          <line className="bat-cell" x1="204" y1="37" x2="204" y2="123" />
          <line className="bat-cell" x1="244" y1="37" x2="244" y2="123" />
          <line className="bat-cell" x1="284" y1="37" x2="284" y2="123" />

          {/* ── Battery fill (animated charge) ── */}
          <g clipPath="url(#bat-clip)">
            <g className="bat-fill-group">
              <rect className="bat-fill-rect" x="124" y="34" width="232" height="92" />
            </g>
          </g>

          {/* ── Lightning bolt icon (appears after charge) ── */}
          <path
            className="bat-bolt"
            d="M 248,52 L 228,84 L 244,84 L 230,110 L 262,76 L 244,76 L 258,52 Z"
          />

          {/* ── Spark: main zigzag path (left → battery) ── */}
          <path
            className="spark-main"
            d="M 0,80 L 38,12 L 56,112 L 86,38 L 108,80 L 120,80"
            filter="url(#sp-glow)"
          />

          {/* ── Branch sparks ── */}
          <line className="spark-branch spark-b1" x1="56" y1="112" x2="26" y2="144" />
          <line className="spark-branch spark-b2" x1="86" y1="38" x2="114" y2="6" />
          <line className="spark-branch spark-b3" x1="38" y1="12" x2="16" y2="28" />
        </svg>

        {/* ── Brand name ── */}
        <div className="splash-logo">
          <span className="splash-logo-name">OSTER</span>
          <span className="splash-logo-sub">BATTERY</span>
        </div>

        <p className="splash-tagline">Powering India Forward</p>

        {/* ── Progress bar ── */}
        <div className="splash-progress-track">
          <div className="splash-progress-bar" />
        </div>

      </div>
    </div>
  );
}

export default SplashScreen;
